import React from 'react';
import { connect } from 'react-redux';
import CompareButton from '../../Components/CompareButton';
import { amountOfProducts } from '../../Actions/Comparison.action';

const CompareButtonContainer = props => (
    <CompareButton {...props}></CompareButton>
);

const mapStateToProps = state => {
    const { comparison } = state;
    return {
        ...comparison,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        amountOfProducts: amount => dispatch(amountOfProducts(amount)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CompareButtonContainer);
